import styled from "styled-components";

export const ActionBar = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme?.colors?.border ?? "rgba(0,0,0,0.08)"};
  margin-bottom: 12px;

  @media (max-width: 640px) {
    align-items: stretch;
  }
`;

export const ActionBarLeft = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const ActionBarRight = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    justify-content: flex-end;
  }
`;
